import React from 'react';

const Footer = (props) => {
    console.log(props)
    return <div className="site-footer text-center">
      <p className="text-muted">Copyright © {(new Date()).getFullYear()} Linkin AB. Alla rättigheter förbehålls.</p>
      <img src={props.template == 'login' ? "https://linkin.se/files/logo-inverse.svg" : "https://linkin.se/files/logo.svg"} width="100"/>
    </div>;
}

export default Footer;
